/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { ProjectCreateModel } from '@sixense/ds-organisations-models';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsProjectCreateService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Create a project.
   *
   * @param project project to create
   * @param organisationId organisation id
   * @returns Observable<ProjectCreateModel>
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createProject(organisationId: number, project: ProjectCreateModel): Observable<any> {
    this.path = `/dsproject/v1/organisations/${organisationId}/project`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.post<any>({ body: project });
  }

  /**
   * Get a project infos.
   *
   * @param projectId Id of the project
   * @returns Observable<ProjectCreateModel>
   */
  public getProjectInfos(projectId: number): Observable<ProjectCreateModel> {
    this.path = `/v1/dsproject/projects/${projectId}`;
    return this.getModel<ProjectCreateModel>();
  }

  /**
   * Update a project.
   *
   * @param projectId Id of the project
   * @param project project to update
   * @returns Observable<ProjectCreateModel>
   */
  public updateProject(projectId: number, project: ProjectCreateModel): Observable<ProjectCreateModel> {
    this.path = `/dsproject/v1/projects/${projectId}`;
    return this.patch<ProjectCreateModel>({ body: project });
  }

  /**
   * Archive a project.
   *
   * @param projectId project id
   * @returns Observable<DsProject>
   */
  public archiveProject(projectId: number): Observable<boolean> {
    this.path = `/dsproject/v1/projects/${projectId}/archive`;
    return this.put({
      body: {
        archived: true,
      },
    });
  }

  /**
   * Create ProjectCreateModel instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `ProjectCreateModel` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): ProjectCreateModel {
    return new ProjectCreateModel(jsonObject);
  }
}
